// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Webinars48Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Webinars48: FC<Webinars48Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="48"
            height="48"
        >
            <path d="M43 41.45V9H5v16H2V9c0-.833.294-1.542.881-2.125A2.898 2.898 0 0 1 5 6h38a2.89 2.89 0 0 1 2.119.881A2.89 2.89 0 0 1 46 9v29c0 .867-.283 1.625-.85 2.275A3.462 3.462 0 0 1 43 41.45Zm-25-13.5c-2.2 0-4-.7-5.4-2.1-1.4-1.4-2.1-3.2-2.1-5.4s.7-4 2.1-5.4c1.4-1.4 3.2-2.1 5.4-2.1s4 .7 5.4 2.1c1.4 1.4 2.1 3.2 2.1 5.4s-.7 4-2.1 5.4c-1.4 1.4-3.2 2.1-5.4 2.1Zm0-3c1.3 0 2.375-.425 3.225-1.275.85-.85 1.275-1.925 1.275-3.225s-.425-2.375-1.275-3.225c-.85-.85-1.925-1.275-3.225-1.275s-2.375.425-3.225 1.275c-.85.85-1.275 1.925-1.275 3.225s.425 2.375 1.275 3.225c.85.85 1.925 1.275 3.225 1.275ZM2 44v-4.7c0-1.267.317-2.35.95-3.25A6.1 6.1 0 0 1 5.4 34c2.233-1 4.375-1.75 6.425-2.25S15.933 31 18 31s4.117.258 6.15.775c2.033.517 4.165 1.261 6.396 2.235 1.043.47 1.88 1.153 2.51 2.048.63.895.944 1.975.944 3.242V44H2Zm3-3h26v-1.7c0-.533-.158-1.042-.475-1.525-.317-.483-.708-.842-1.175-1.075-2.133-1.033-4.083-1.742-5.85-2.125A25.871 25.871 0 0 0 18 34c-1.9 0-3.75.192-5.55.575-1.8.383-3.75 1.092-5.85 2.125a2.84 2.84 0 0 0-1.15 1.075c-.3.483-.45.992-.45 1.525V41Z" />
        </svg>
    );
};

export default Webinars48;
